import {
  LOADING,
  CITY_LIST,
  SLIDER_LIST,
  AREA_LIST,
  OCCASION_LIST,
  FUNCTION_LIST,
  ESSENTIAL_LIST,
  ESSENTIAL_TYPE_LIST,
  DASHBOARD,
  ORDER_LIST,
  ORDER_DETAIL_LIST,
  VENUES_LIST,
  GALLERY_LIST,
  YOUTUBE_LIST,
  USER_LIST,
  BOOKING_LIST,
} from "../common/constant";

const initialState = {
  loading: false,
  dashboard: {},
  gallery_list: {},
  youtube_list: {},
  user_list: {},
  booking_list: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD:
      return { ...state, dashboard: action.payload };
    case CITY_LIST:
      return { ...state, city_list: action.payload };
    case AREA_LIST:
      return { ...state, area_list: action.payload };
    case LOADING:
      return { ...state, loading: action.payload };
    case SLIDER_LIST:
      return { ...state, slider_list: action.payload };
    case OCCASION_LIST:
      return { ...state, occasion_list: action.payload };
    case FUNCTION_LIST:
      return { ...state, function_list: action.payload };
    case VENUES_LIST:
      return { ...state, venues_list: action.payload };
    case ESSENTIAL_LIST:
      return { ...state, essential_list: action.payload };
    case ESSENTIAL_TYPE_LIST:
      return { ...state, essential_type_list: action.payload };
    case ORDER_LIST:
      return { ...state, order_list: action.payload };
    case ORDER_DETAIL_LIST:
      return { ...state, order_details: action.payload };
      case BOOKING_LIST:
    return {...state,  booking_list: action.payload,};
          case GALLERY_LIST:
      return { ...state, gallery_list: action.payload };
    case YOUTUBE_LIST:
      return { ...state, youtube_list: action.payload };
      case USER_LIST:
  return { ...state, user_list: action.payload };

    default:
      return state;
  }
};
